import React, { AnchorHTMLAttributes, memo, ReactElement, ReactNode, useMemo } from 'react';

// Define prop sets for phone and email, using a discriminated union
interface BaseProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
	children: ReactNode;
}

type ContactLinkProps = ({ type: 'phone'; value: string } & Omit<BaseProps, 'href'>) | ({ type: 'email'; value: string } & Omit<BaseProps, 'href'>);

const ContactLink = memo(({ type, value, children, className, ...anchorProps }: ContactLinkProps): ReactElement => {
	// Compute href only when dependencies change
	const href = useMemo(() => {
		return type === 'phone' ? `tel:${value}` : `mailto:${value}`;
	}, [type, value]);

	return (
		<a href={href} {...anchorProps} className={className}>
			{children}
		</a>
	);
});

// Define display name for better debugging
// ContactLink.displayName = 'ContactLink';

export default ContactLink;
